import { ChangeDetectorRef } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { debounceTime, delay, distinctUntilChanged, filter, finalize, first, map, Observable, of, switchMap, take, tap } from 'rxjs';
import { VatNumberService } from '../services/vat-number.service';

export class VatNumberValidator {
  static createValidator(vatNumberService: VatNumberService, cd: ChangeDetectorRef): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors> => {
      // return vatNumberService.validateVatNumber(control.value).pipe(
      //   map(result => (!result.valid ? { VatNumberInvalid: true } : {})),
      //   tap(a => cd.markForCheck())
      //   );

      return of(control.value).pipe(
        delay(350),
        switchMap(value => {
          return vatNumberService.validateVatNumber(value);
        }),
        tap(() => cd.markForCheck()),
        map(result => (!result.valid ? { VatNumberInvalid: true } : {})),
        first()
      );
    };
  }
}
